<template>
  <div class="m-0">
    <Button btn-class="btn-sm" type="new" id="submit_btn" btn-text="crm-setting.activity_add" :isDisabled="isDisabled" @click="toggleChoiceTypeModal"></Button>

    <div class="modal fade" id="activity-type-create-modal" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title"> {{$t("crm.pipeline.activity.liste")}} </h5>
            <div @click.prevent="toggleChoiceTypeModal" class="btn btn-icon btn-sm btn-active-light-primary ms-2" aria-label="Close">
              <i class="las la-times fs-1"></i>
            </div>
          </div>
          <div class="modal-body">
            <div class="d-flex align-items-center justify-content-center flex-wrap gap-4">
              <div class="h-100px w-100px" v-for="activityType in activityTypes" :key="activityType.id">
                <div
                    :style="{backgroundColor: activityType.color + 20, color: activityType.color}"
                    class="card d-flex flex-column align-items-center py-7 px-3 cursor-pointer hover-scale text-capitalize fs-7"
                    @click="toggleActivityModal(activityType.id, activityType.type)">
                  <i :style="{color: activityType.color}" :class="activityType.icon" class="fs-2 mb-2"></i>
                  {{activityType.name}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { defineEmits, defineProps} from "vue";
import {useRouter} from "vue-router";
import {useStore} from "vuex";
import Button from "@/components/Button.vue"

const store = useStore()
const router = useRouter()

const emits = defineEmits(['handleClick'])

const props = defineProps({
  activityTypes: { type: Array, required: true },
  isDisabled: {type: Boolean, required: false}
})

const toggleChoiceTypeModal = () => {
  $('#activity-type-create-modal').modal('toggle')
}
const toggleActivityModal = (id, activityType) => {
  $('#activity-type-create-modal').modal('hide')
  emits('handleClick', {id, activityType})
}


</script>

<style scoped>
.hover-scale:hover {
  transform: scale(1.1);
  transition: transform .3s ease-in;
}
</style>
